<!--    This needs to be integrated with the header in organization-customer.html and customer-header.html (from pkrey)  -->

<header class="header--page" *ngIf="!inModal">
    <ul class="header__nav">
        <li class="header__back" title="Back to Results">
            <a class="icon--back-results" href="javascript:void(0);" (click)="navigateBack()" [ngClass]="{hidden: !showBack}"></a>
        </li>
        <li class="header__organization" title="View Organization" [attr.aria-expanded]="tab == tabs.Customer" (click)="changeTab(tabs.Customer)">
            <h1 class="header__circle">
                <i class="material-icons">business</i>
                <span class="header__block" href="javascript:void(0)">{{organizationDetails.nameDetail.organizationName}}<span class="header__block__sub">id:&nbsp;{{ organizationDetails.id }}</span></span>
            </h1>
        </li>
        <li class="header__pages">
            <ul class="header__pages__links">
                <li [ngClass]="{isActive: tabs.Customer == tab }">
                    <a class="list__link" href="javascript:void(0);" title="Organization" (click)="changeTab(tabs.Customer)"><i class="material-icons">business</i></a>
                </li>
                <li [ngClass]="{isActive: tabs.Vehicle == tab}">
                    <a class="list__link" href="javascript:void(0);" title="Vehicles" (click)="changeTab(tabs.Vehicle)"><i class="material-icons">directions_car</i></a>
                </li>
                <li [ngClass]="{isActive: tabs.Accounts == tab}" *ngIf="organizationDetails.level >= 3">
                    <a class="list__link" href="javascript:void(0);" title="Accounts" (click)="changeTab(tabs.Accounts)"><i class="material-icons">work</i><sup>{{numberOfAccounts}}</sup></a>
                </li>
                <li [ngClass]="{isActive: tabs.Affiliations == tab}">
                    <a class="list__link" href="javascript:void(0);" title="Affiliations" (click)="changeTab(tabs.Affiliations)"><i class="material-icons">group</i></a>
                </li>
                <li [ngClass]="{isActive: tabs.Documents == tab}">
                    <a class="list__link" href="javascript:void(0);" title="Documents" (click)="changeTab(tabs.Documents)"><i class="material-icons">description</i></a>
                </li>
                <li>
                    <a class="list__link" href="javascript:void(0);" title="Notes" (click)="openNotesModal()"><i class="material-icons">note</i><sup><span class="note-count"></span></sup></a>
                </li>
                <li *ngIf="auth.hasSecurityTransactionClaim(securityTransactionType.CustomerSurveySendSMS)">
                    <a class="list__link" href="javascript:void(0);" title="Send Customer Survey" (click)="openSendCustomerSurveyModal()"><i class="material-icons">reviews</i></a>
                </li>
                <li>
                    <a class="list__link" href="javascript:void(0);" title="Setup An Appointment" (click)="createAppointment()"><i class="material-icons">today</i></a>
                </li>
            </ul>
        </li>
    </ul>
</header>
<div [ngClass]="{mvd_container: !inModal}" [ngSwitch]="tab">
    <ng-container *ngSwitchCase="tabs.Customer">
        <header class="header--well">
            <ul>
                <li class="header__title" *ngIf="!inModal">
                    <h2>{{title}}<span class="deceased" *ngIf="organizationDetails.statusTypeId == customerStatusTypes.Closed.id">&nbsp;(Do Not Use this Record)</span></h2>
                </li>
                <li>
                    <ul class="list--views">
                        <li>
                            <a class="list__link" href="javascript:void(0);" (click)="toggleView()">{{titleLink}}</a>
                        </li>
                        <li>
                            <a class="list__link" href="javascript:void(0);" (click)="changeTab(tabs.CustomerServiceHistory)">View Service History</a>
                        </li>
                    </ul>
                </li>
            </ul>
        </header>
        <div class="well">
            <div class="list--ancors" *ngIf="showAll && !inModal">
                <ul class="list--menu">
                    <li>
                        <a class="list__link" href="javascript:void(0);" (click)="goTo('Name')">Name</a>
                    </li>
                    <li>
                        <a class="list__link" href="javascript:void(0);" (click)="goTo('Customer')">Customer</a>
                    </li>
                    <li>
                        <a class="list__link" href="javascript:void(0);" (click)="goTo('Address')">Address</a>
                    </li>
                    <li>
                        <a class="list__link" href="javascript:void(0);" (click)="goTo('Contact')">Contact</a>
                    </li>
                    <li>
                        <a class="list__link" href="javascript:void(0);" (click)="goTo('Identification')">Identifications</a>
                    </li>
                    <li>
                        <a class="list__link" href="javascript:void(0);" (click)="goTo('Characteristic')">Characteristics</a>
                    </li>
                    <li>
                        <a class="list__link" href="javascript:void(0);" (click)="goTo('Representatives')">Representatives</a>
                    </li>
                    <li>
                        <a class="list__link" href="javascript:void(0);" (click)="goTo('Placard')">Placards</a>
                    </li>
                    <li>
                        <a class="list__link" href="javascript:void(0);" (click)="goTo('Insurance')">Insurance</a>
                    </li>
                </ul>
            </div>

            <customer-names id="Name" [names]="names" [customerNumber]="organizationDetails.id" [canEdit]="organizationDetails.accessControls[accessControlTypes.UpdCustName.id]"></customer-names>
            <organization-customer-details 
								id="Customer" 
								[details]="details" 
								[customerNumber]="organizationDetails.id"
								(customerStatusTypeIdChange)="customerStatusTypeChanged($event)">
			</organization-customer-details>
            <address-component	[addresses]="organizationDetails.addresses"
                            	[entityId]="organizationDetails.id"
                            	[componentTitle]="'Addresses'"
                            	[componentTypeName]="'organization-customer'"
                            	[canEdit]="organizationDetails.accessControls[accessControlTypes.UpdCustAddress.id]"
                            	[canSetUndeliverable]="organizationDetails.accessControls[accessControlTypes.SetAddressUndeliverable.id]"
                            	[showHistoryButton]="true"
                            	id="Address"
                            	[isACP]="false"
                            	(onAddressesUpdated)="customerAddressesUpdated($event)">
            </address-component>
            <customer-contact id="Contact" [contacts]="organizationDetails.contacts" [customerNumber]="organizationDetails.id" [canEdit]="organizationDetails.accessControls[accessControlTypes.UpdCustContact.id]" [isFullRedactionNecessary]="isFullRedactionNecessary"></customer-contact>

            <ng-container *ngIf="showAll">
                <customer-identification id="Identification" [identifications]="organizationDetails.identifications" [customerNumber]="organizationDetails.id" [canEdit]="organizationDetails.accessControls[accessControlTypes.UpdCustIdentification.id]"></customer-identification>
                <customer-characteristic id="Characteristic" 
                    [characteristics]="organizationDetails.characteristics" 
                    [customerNumber]="organizationDetails.id" 
                    [canEdit]="organizationDetails.accessControls[accessControlTypes.UpdCustCharacteristic.id]" 
                    [canRemove]="organizationDetails.accessControls[accessControlTypes.CanRemoveACPCharacteristic.id]"
                    (acpChanged)="acpChanged($event)"
                    (onCharacteristicChange)="reloadData($event)">
                </customer-characteristic>
                <customer-representative id="Representatives" [representatives]="" [customerNumber]="organizationDetails.id" [canEdit]="organizationDetails.accessControls[accessControlTypes.UpdCustRepresentatives.id] && organizationDetails.level >= 3"></customer-representative>
                <customer-placard id="Placard" [placards]="" [customerNumber]="organizationDetails.id"></customer-placard>
                <customer-insurance id="Insurance" [customerNumber]="organizationDetails.id"></customer-insurance>
            </ng-container>
        </div>
    </ng-container>
    <ng-container *ngSwitchCase="tabs.Vehicle">
        <header class="header--well" *ngIf="!inModal">
            <ul>
                <li class="header__title">
                    <h2>Vehicle Summary</h2>
                </li>
            </ul>
        </header>
        <div class="well">
            <customer-vehicle (vehicleSelected)="changeTab(tabs.VehicleDetails, $event)" [vehicles]="organizationDetails.vehicles" [customerNumber]="organizationDetails.id"></customer-vehicle>
            <customer-fleet [customerNumber]="organizationDetails.id" [customerTypeId]="customerTypes.Organization.id"></customer-fleet>
        </div>
    </ng-container>

    <customer-account-summary *ngSwitchCase="tabs.Accounts" (accountClicked)="changeTab(tabs.AccountDetails, $event)" (accountCreated)="changeTab(tabs.AccountEdit, $event)" [customerNumber]="organizationDetails.id"></customer-account-summary>
    <customer-account-details *ngSwitchCase="tabs.AccountDetails" (editClicked)="changeTab(tabs.AccountEdit, $event)" (requestDisbursementClicked)="changeTab(tabs.DisbursementRequest, $event)" (serviceHistoryClicked)="changeTab(tabs.ServiceHistory, $event)" [customerAccountNumber]="customerAccountNumberId"></customer-account-details>
    <edit-customer-account *ngSwitchCase="tabs.AccountEdit" [customerAccountNumber]="customerAccountNumberId" (navigateBack)="navigateBack()"></edit-customer-account>
    <disbursement-request *ngSwitchCase="tabs.DisbursementRequest" [customerAccountNumberId]="customerAccountNumberId" [customerNumberId]="customerNumber" [names]="names" (navigateBack)="navigateBack()"></disbursement-request>
    <customer-account-transaction-search *ngSwitchCase="tabs.ServiceHistory" [customerAccountNumberId]="customerAccountNumberId"></customer-account-transaction-search>
    <customer-affiliation *ngSwitchCase="tabs.Affiliations" [customerNumber]="organizationDetails.id" [canEdit]="true"></customer-affiliation>
    <vehicle-information *ngSwitchCase="tabs.VehicleDetails" [vehicleId]="vehicleDetailId" [includeHeader]="false"></vehicle-information>

    <div class="well" *ngSwitchCase="tabs.Documents">
        <document-retrieve-upload [searchDocumentDataCollection]="searchDocumentDataCollection" [hideCloseButton]="true"></document-retrieve-upload>
    </div>
    <div class="mvd_container" *ngSwitchCase="tabs.CustomerServiceHistory">      
        <service-history [customerNumber] ="customerNumber"></service-history>
    </div>
</div>
<div class="list--ancors__spacer" *ngIf="showAll && !inModal"></div>
